import { combineReducers } from 'redux'
import LoginReducer from '../Container/Login/LoginReducer'
import CarListReducer from '../Container/UrCar/UrCarReducer'
import DealerReducer from '../Container/DealerRedux/DealerReducer'

// import todos from './todos'
// import counter from '../Pages/ReduxTest/counterReducer'

// export default combineReducers({
//   // todos,
//   counter
// })

export default combineReducers({
    LoginReducer,
    CarListReducer,
    DealerReducer
  })